module.exports = __webpack_public_path__ + "img/Shape.843ef1de.svg";